import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { UserRole } from '../../models/user-role.model';
import { AuthStorageService } from '../services/auth-storage.service';

export const authGuard = (roles: UserRole | UserRole[], redirectRoute = '/login'): CanActivateFn => {
  return (route, state): boolean => {
    const authStorageService: AuthStorageService = inject(AuthStorageService);
    const router: Router = inject(Router);
    const userRole: UserRole | null = authStorageService.getUserRole();
    const token = authStorageService.getToken();
    const isAccessAllowed = checkIfCanAccess(roles, userRole, token);

    if (!isAccessAllowed) {
      router.navigate([redirectRoute], { state: { redirectUrl: state.url } });
    }

    return isAccessAllowed;
  };
};

export const checkIfCanAccess = (
  allowedRoles: UserRole | UserRole[],
  userRole: UserRole | null,
  token: string | null,
): boolean => {
  const allowedRolesArray = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];
  if (userRole) {
    const isRoleAllowed = allowedRolesArray.includes(userRole);
    return !!token && isRoleAllowed;
  }
  return false;
};
